__turbopack_context__.v({
  "border": "TalesBlockImageFull-module-scss-module__ArKrzG__border",
  "caption": "TalesBlockImageFull-module-scss-module__ArKrzG__caption",
  "fade-in": "TalesBlockImageFull-module-scss-module__ArKrzG__fade-in",
  "image": "TalesBlockImageFull-module-scss-module__ArKrzG__image",
  "inner": "TalesBlockImageFull-module-scss-module__ArKrzG__inner",
  "isInView": "TalesBlockImageFull-module-scss-module__ArKrzG__isInView",
  "media": "TalesBlockImageFull-module-scss-module__ArKrzG__media",
  "root": "TalesBlockImageFull-module-scss-module__ArKrzG__root",
});
